<template>
  <div class="credential-editor">
    <p v-if="schema.separator" class="credential-note">
      این مقدارها جدا ذخیره نمی‌شوند. موقع ثبت، با «{{ schema.separator }}» به هم وصل می‌شوند
      و بک‌اند دوباره همان‌ها را از هم جدا می‌کند.
    </p>

    <div v-if="locked" class="credential-lock">
      <b-icon icon="lock"></b-icon>
      <div>
        <strong>مقدار فعلی محرمانه است</strong>
        <p>برای اینکه مقدار قبلی پاک نشود، تا وقتی دکمه جایگزینی را نزنید چیزی ذخیره نمی‌شود.</p>
      </div>
      <button type="button" class="credential-replace" @click="$emit('unlock')">
        جایگزینی مقدار
      </button>
    </div>

    <div v-else class="credential-list">
      <div v-for="(field, index) in schema.fields" :key="field.key" class="credential-item">
        <div class="credential-index">{{ index + 1 }}</div>
        <div class="credential-body">
          <label :for="`credential-${field.key}`">{{ field.label }}</label>
          <p>{{ field.hint }}</p>
          <textarea
              v-if="field.multiline"
              :id="`credential-${field.key}`"
              class="form-control"
              rows="4"
              dir="ltr"
              :value="parts[field.key]"
              @input="$emit('update-part', field.key, $event.target.value)"
          ></textarea>
          <div v-else class="credential-input">
            <input
                :id="`credential-${field.key}`"
                class="form-control"
                :dir="field.ltr ? 'ltr' : 'rtl'"
                :type="field.secret && !visible[field.key] ? 'password' : 'text'"
                :value="parts[field.key]"
                @input="$emit('update-part', field.key, $event.target.value)"
            />
            <button
                v-if="field.secret"
                type="button"
                class="credential-eye"
                @click="toggle(field.key)"
            >
              <b-icon :icon="visible[field.key] ? 'eye-slash' : 'eye'"></b-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <p v-if="error" class="credential-error">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: "GatewayCredentialFields",
  props: {
    schema: {type: Object, required: true},
    parts: {type: Object, required: true},
    locked: {type: Boolean, default: false},
    error: {type: String, default: ''},
  },
  data() {
    return {visible: {}};
  },
  methods: {
    toggle(key) {
      this.$set(this.visible, key, !this.visible[key]);
    },
  },
};
</script>

<style scoped>
.credential-editor {
  margin-top: 8px;
}

.credential-note,
.credential-lock p,
.credential-body p {
  color: #6b7280;
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
}

.credential-note {
  background: rgba(235, 61, 96, 0.08);
  border-radius: 14px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.credential-lock {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border: 1px solid #f0e4df;
  border-radius: 16px;
  padding: 14px;
}

.credential-lock .b-icon {
  color: #eb3d60;
  font-size: 20px;
}

.credential-replace,
.credential-eye {
  border: 0;
  background: #1e1e1e;
  color: #fff;
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: 700;
  white-space: nowrap;
}

.credential-eye {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: #6b7280;
}

.credential-list {
  display: grid;
  gap: 12px;
}

.credential-item {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 12px;
  background: #fff;
  border: 1px solid #f0e4df;
  border-radius: 16px;
  padding: 14px;
}

.credential-index {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: rgba(235, 61, 96, 0.12);
  color: #eb3d60;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

.credential-body label {
  display: block;
  font-weight: 800;
  color: #1e1e1e;
  margin-bottom: 4px;
}

.credential-input {
  position: relative;
  margin-top: 8px;
}

.credential-input input {
  padding-left: 42px;
}

.credential-body textarea {
  margin-top: 8px;
}

.credential-error {
  color: #b42318;
  background: #fff1f0;
  border-radius: 12px;
  padding: 10px 12px;
  margin: 12px 0 0;
}
</style>
